// extracted by mini-css-extract-plugin
export default {"awsui":"style_awsui__hGFhp"};